import Color from 'color'

export default {
  ORANGE: '#FFB150',
  RED: 'rgb(242, 29, 29)',
  PINK: 'rgb(167,22,73)',
  MEDIUM_PINK: 'rgb(190, 27, 86)',
  LIGHT_PINK: 'rgb(205,49,114)',
  BLUE: 'rgb(23,113,145)',
  DARK_BLUE: 'rgb(19,106,136)',
  PURPLE: '#AC5FD6',
  GREEN: '#91EB43',
  FATHER_COAL: 'rgb(21, 32, 34)',
  COAL: 'rgb(33,45,49)',
  MEDIUM_COAL: 'rgb(39,49,51)',
  DARKER_GRAY: 'rgb(45,56,58)',
  DARK_GRAY: 'rgb(47, 57, 60)',
  GRAY: 'rgb(52,63,65)',
  LIGHTER_GRAY: 'rgb(62,72,74)',
  LIGHTEST_GRAY: 'rgb(77, 89, 92)',
  DARKER_ROCK: 'rgb(180, 180, 180)',
  DARKER_ROCK2: 'rgb(127, 134, 136)',
  DARK_ROCK_MUTED: 'rgba(180, 180, 180, .5)',
  DARK_ROCK_MUTED2: 'rgba(180, 180, 180, .1)',
  SHADY: 'rgba(21, 32, 34, .3)',


  // New stuff TODO: unify!

  LIGHT_BLUE: '#5DE2F9', // instances need to be switched to BLUE_ON_LIGHT, and REAL_LIGHT_BLUE should be renamed to LIGHT_BLUE in keeping with Creator
  REAL_LIGHT_BLUE: 'rgb(38,145,173)',
  BLUE_ON_LIGHT: '#5DE2F9',
  LIGHTEST_PINK: '#FF6EA8',
  LIGHTEST_BLUE: '#ACEBFF',
  DARK_ROCK: '#5B7373',
  ROCK: '#C0CCCD', // Making ROCK a bit colder
  ROCK_MUTED: Color('#C0CCCD').fade(0.37),
  SUNSTONE: 'rgb(254,254,254)', // This is our "white", use sparingly
  GRAY_FIT1: '#405355' // used for tree line
}



// WEBPACK FOOTER //
// ./src/components/assets/palette.js